import {useState, useEffect, useContext} from 'react'
import {ThemeContext} from '../Helper/Context'
import ReactCodeInput from "react-code-input";
import useFetch from './useFetch'

const Verifyemailcode = ({hidePopup}) => {
    const {mainState, setMainState} = useContext(ThemeContext);
    const {setShowLoader} = useContext(ThemeContext)
    const [{response}, dofetch] = useFetch();
    const [resendState, setResendState] = useState(false)
    const [apiName, setApiName] = useState(null)
    const [pinCode, setPinCode] = useState("");
    const [error, setError] = useState(false);
    
    // const [verifyEmail, setVerifyEmail] = useState ({
    //     showVerifyCode:false,
    //     verified:false
    // });
    const handleVerifyCodeSubmit = (e) => {
        // setErrors(Validation(verifyCodeFields,'verifycode'))

        // setMainState({
        //     ...mainState,
        //     section:'dashboard',
        //     isLoggedIn:true,
        //     showVerification:false
        // }) 
        if (pinCode.length > 5){
            
            console.log('verifycode api');
            setApiName('verifycode');
            let body = "{\"code\": \""+pinCode+"\",\"memberId\": "+mainState.user.userId+"}";
            dofetch(mainState.fetchURL, 'VerifyOneTimeCode', 'VerifyOneTimeCode.post.odata','', body);

        }else{
            setError(true);
        }
    }

    const resendOneTimeCodeSMS = (e, resent)=>{
        // setPinCode('');
        console.log('resend OneTimeCodeSMS api');
        resent ? setApiName('reSendOneTimeCode') : setApiName('sendOneTimeCode');
        
        let body = "{\"memberId\": "+mainState.user.userId+",\"codeDestination\": \"Sms\"}";
        dofetch(mainState.fetchURL, 'SendOneTimeCode', 'SendOneTimeCode.post.odata','', body);
    }

    const sendOneTimeCodeEmail = (e, resent)=>{
        // setPinCode('');
        console.log('send OneTimeCodeEmail api');
        resent ? setApiName('reSendOneTimeCode') : setApiName('sendOneTimeCode');
        let body = "{\"memberId\": "+mainState.user.userId+",\"codeDestination\": \"Email\"}";
        dofetch(mainState.fetchURL, 'SendOneTimeCode', 'SendOneTimeCode.post.odata','', body);
    }

    const handlePinChange = pinCode => {
        setPinCode(pinCode);
    };
    

    useEffect(()=>{
        if(response){
            if(apiName === 'verifycode'){
                console.log(response);
                setShowLoader(false)
                if(response.codeMatches === true){
                    setError(false);
                    setMainState({
                        ...mainState,
                        section:'dashboard',
                        isLoggedIn:true,
                        showVerification:false
                    })                    
                }else{
                    setError(true);
                    setPinCode('');
                }
            }

            if(apiName === 'sendOneTimeCode'){
                setShowLoader(false);
                console.log(response);
                if(response.error){
                    alert(response.errors[0].message)
                }else{
                    setMainState(prevState=>({
                        ...prevState,
                        ...prevState.showVerification,showVerification:true,
                    }))
                }
            }

            if(apiName === 'reSendOneTimeCode'){
                setShowLoader(false);
                setResendState(true);
                console.log(response);
                if(response.error){
                    alert(response.errors[0].message)
                }else{
                    setMainState(prevState=>({
                        ...prevState,
                        ...prevState.showVerification,showVerification:true,
                    }))
                }
            }
             
        }
    },[response, apiName])

    return (
        <div className="perfectgym-popup verifyemail" onClick={e=>{hidePopup(e)}}>
            <div className="popup-content">
                <div className="closebtn" onClick={(e) => setMainState({...mainState, showVerification:false})}><i className="fal fa-times"></i></div>
                <div className="icon-wrapper envelop"><i className="fal fa-envelope"></i></div>
                <h2>Verify Your Email Address</h2>
                <p>We have sent a 6 digits code to the phone number that we have in our system (ends in **** *** {mainState.user.phoneNumber.slice(-3)}). Once received, please enter the code below to verify your account and we will proceed with those details</p>
                <ReactCodeInput 
                    type='number' 
                    fields={6}
                    onChange={handlePinChange} 
                    value={pinCode}
                    className="verification-code-wrapper"
                />
                {pinCode.length < 6 && error && <span className="verification-code-error Error">Please enter a valid code</span>}
                
                {resendState && <strong>Resend has been successful!</strong>}
                <p className="resendtext">Didn’t recive the code? <span className="link" onClick={(e) => resendOneTimeCodeSMS(e, true)}><strong>Resend</strong></span> or <span className="link" onClick={(e) =>  sendOneTimeCodeEmail(e, true)}><strong>send</strong> to email</span></p>
                <button className="btn" onClick={e => handleVerifyCodeSubmit(e)}>Verify</button>
            </div>
        </div>
    )
}
export default Verifyemailcode
